export const mbtiData = [
  'ENFJ',
  'ENFP',
  'ENTJ',
  'ENTP',
  'ESTP',
  'ESFP',
  'ESTJ',
  'ESFJ',
  'INFJ',
  'INFP',
  'INTJ',
  'INTP',
  'ISTP',
  'ISFP',
  'ISFJ',
  'ISTJ'
]
